import {TextField} from 'bonprix-design-system';
import { startTransition } from 'react';
import { useContactForm } from './ContactFormContext';

export function AdditionalField({formErrors, cdaEntry, additionalField, index}) {
    const { formValues, setFormValues } = useContactForm();

    const handleChange = (newValue) => {
        startTransition(() => {
            if (typeof index === 'number') {
                setFormValues((prevValues) => {
                    const newValues = [...prevValues[additionalField.name] || []];
                    newValues[index] = newValue;

                    return {
                        ...prevValues,
                        [additionalField.name]: newValues,
                    };
                });
            } else {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    [additionalField.name]: newValue,
                }));
            }
        })
    }

    return (
        <div className="form-row">
            <TextField
                label={additionalField.label}
                maxLength="100"
                value={typeof index === 'number' ? formValues[additionalField.name]?.[index] : formValues[additionalField.name]}
                name={additionalField.name}
                onChange={handleChange}
                error={formErrors && !!formErrors[additionalField.name]}
                errorText={formErrors && formErrors[additionalField.name] && cdaEntry.fields[formErrors[additionalField.name]]}
            />
        </div>
        )
    }
